{
  "appType": "aaas",
  "assetsUrl": "https://app-3as.visitor-analytics.io/",
  "standaloneBaseUrl": "https://app.visitor-analytics.io/",
  "translationsUrl": "https://cdn.twipla.com/translations/dashboard",
  "announcementModalApiUrl": "https://www.twipla.com/api/v1/inapp/bubbles/index.php",
  "announcementBannerApiUrl": "https://www.twipla.com/api/v1/inapp/banners/index.php",
  "dashboardTilesApiUrl": "https://www.twipla.com/api/v1/inapp/tiles/",
  "wixAppId": "13ee53b4-2343-b641-c84d-056d2e6ed2e6",
  "dashboardWebsiteId": "a8a6db38-b652-11f1-9c4b-960004340fd3",
  "workerEnv": "production",
  "wixBaseUrl": "https://dashboard.va-endpoint.com/",
  "apiUrl": "https://api.twipla.com/api",
  "aiApiUrl": "https://ai.twipla.com",
  "gatewayApiUrl": "https://api-gateway.twipla.com",
  "paddleVendorId": 122665,
  "paddleSandbox": false,
  "wixIgnoreVisitsUrl": "https://loadbalancer.visitor-analytics.io/worker-messages",
  "reCaptchaSiteKey": "6LeN9dkUAAAAAJn80caMCZcQf3LTdceByXtTeQhF",
  "statsOverviewReleaseDate": 1577836800,
  "chatwootToken": "6PKafZ6wwTAdrR3FgDUzxnq3",
  "env": "prod",
  "surveysUrl": "https://surveys.visitor-analytics.io",
  "firstPromoter": {
    "apiUrl": null,
    "apiKey": null,
    "wId": null
  },
  "competitionReleaseDate": 1596319200,
  "supportedLanguages": [
    "en",
    "de",
    "es",
    "pt",
    "it",
    "fr",
    "ro"
  ],
  "customDomain": ".visitor-analytics.io",
  "maintenancePeriods": [
    [
      "2024-12-06T03:30:00.000Z",
      "2024-12-06T05:30:00.000Z"
    ],
    [
      "2024-11-06T03:30:00.000Z",
      "2024-11-06T05:30:00.000Z"
    ]
  ],
  "flagSmithEnvironmentId": "Txqa9mNe6JWD9Lnya34BRR",
  "sentryDsn": "https://38dc1a994a42cfb9f8e479ca26a80439@sentry.visitor-analytics.io/2",
  "sentryAuthToken": "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",
  "sourceTag": "3.54.0-1"
}
